import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { Divider, MenuItem, Switch, TextField } from '@mui/material';
import styles from './AddCategory.module.css';
import CategoryTable from '../components/CategoryTable';
import APIURL from '../api/apiClient';
import { message } from 'antd';

function AddCategory() {
    const [refreshTrigger, setRefreshTrigger] = useState(0); // 👈 add this
  const [formData, setFormData] = useState({
    name: '',
    thumbnail: '',
    status: 1,
    featured: '',
  });

  const [errorMessage, setErrorMessage] = useState('');
  const fileInputRef = useRef(null);

  const validate = () => {
    if (!formData.name.trim()) {
      setErrorMessage('Name is required.');
      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleDeleteImage = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      images: prevData.images.filter((_, imgIndex) => imgIndex !== index),
    }));
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === 'checkbox') {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked ? 1 : 0,
      }));
    } else if (type === 'file') {
      if (name === 'thumbnail') {
        const thumbnailFile = files[0];
        if (thumbnailFile) {
          // Revoke the previous URL to free memory
          if (formData.thumbnailPreview) {
            URL.revokeObjectURL(formData.thumbnailPreview);
          }
          const thumbnailPreview = URL.createObjectURL(thumbnailFile);
          setFormData((prevData) => ({
            ...prevData,
            thumbnail: thumbnailFile,
            thumbnailPreview,
          }));
        }
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };


  useEffect(() => {
    return () => {
      if (formData.thumbnailPreview) {
        URL.revokeObjectURL(formData.thumbnailPreview);
      }
    };
  }, [formData.thumbnailPreview]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    const formPayload = new FormData();
    formPayload.append('name', formData.name);
    formPayload.append('status', formData.status);
    formPayload.append('featured', formData.featured);

    // Ensure formData.thumbnail exists before appending
    if (formData.thumbnail instanceof File) {
      console.log('Adding thumbnail:', formData.thumbnail);
      formPayload.append('thumbnail', formData.thumbnail);
    } else {
      console.warn("Thumbnail is not a valid File object:", formData.thumbnail);
    }

    // **LOG BEFORE SENDING**
    console.log("Sending form data to backend...");
    for (let [key, value] of formPayload.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      // ✅ APIURL.post will return parsed JSON object
      let response = await APIURL.post('/insertcategory.php', formPayload, true);

      console.log("Response received from backend:", response);

      // If response is a string (not JSON), try to parse it
      if (typeof response === "string") {
        try {
          response = JSON.parse(response.trim());
        } catch {
          // fallback if not JSON
          response = { success: false, message: response };
        }
      }

      if (response.success) {
        message.success("Category Added Successfully");
        setErrorMessage(''); // clear old errors
        setFormData({
          name: '',
          thumbnail: null,
          status: 1,
          featured: '',
        });
        setRefreshTrigger((prev) => prev + 1); // 👈 trigger refresh
      } else {
        setErrorMessage(response?.error || response?.message || 'Submission failed.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setErrorMessage('Submission failed. Please try again.');
    }
  };




  return (

    <div className={styles.categoryContainer}>
      <div className="container mt-4">
        <div className="row d-flex align-items-start">
          {/* Left Side: Create Category Form */}
          <div className="col-md-5">
            <h2>Create Category</h2>
            <form onSubmit={handleSubmit}>
              {/* Name Input */}
              <div className={styles.formGroup}>
                <TextField
                  type="text"
                  name="name"
                  size='small'
                  label="Category Name"
                  className={styles.formControl}
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              {errorMessage && (
                <div className={styles.errorMessage}>{errorMessage}</div>
              )}

              {/* Thumbnail Upload */}
              <div className={styles.thumbnailSection}>
                <label htmlFor="thumbnail" className={styles.thumbnailLabel}>
                  {formData.thumbnailPreview ? (
                    <>
                      <img
                        src={formData.thumbnailPreview}
                        alt="Thumbnail Preview"
                        className={styles.thumbnailPreview}
                      />
                      <span>Change Thumbnail</span>
                    </>
                  ) : (
                    <>
                      <div className={styles.uploadIcon}>+</div>
                      <span>Add Thumbnail</span>
                    </>
                  )}
                  <input
                    type="file"
                    name="thumbnail"
                    id="thumbnail"
                    onChange={handleChange}
                    accept="image/png, image/jpeg, image/webp"
                    className={styles.fileInput}
                  />
                </label>
              </div>

              {/* Status Switch */}
              <div className={styles.switchContainer}>
                <span className={styles.switchLabel}>Status</span>
                <Switch
                  checked={formData.status === 1}
                  onChange={(e) =>
                    handleChange({
                      target: {
                        name: 'status',
                        type: 'checkbox',
                        checked: e.target.checked,
                      },
                    })
                  }
                  name="status"
                />
              </div>

              {/* Featured Dropdown */}
              <div className={styles.formGroup}>
                <TextField
                  select
                  name="featured"
                  size='small'
                  label="Featured"
                  className={styles.formControl}
                  value={formData.featured}
                  onChange={handleChange}
                  required
                >
                  <MenuItem value="" disabled>
                    Select Featured Option
                  </MenuItem>
                  <MenuItem value="1">Computer</MenuItem>
                  <MenuItem value="0">Laptop</MenuItem>
                </TextField>
              </div>

              {/* Submit Button */}
              <button type="submit" className={styles.submitButton}>
                Submit
              </button>
            </form>
          </div>

          {/* Vertical Divider */}
          {/* <div className="col-auto d-flex justify-content-center">
            <Divider
              orientation="vertical"
              flexItem
              sx={{ borderColor: "grey.400", height: "100%" }}
            />
          </div> */}

          {/* Right Side: Category Table */}
          <div className="col-md-7">
            <CategoryTable  refreshTrigger={refreshTrigger} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddCategory;